import React from "react";
import { FaTaxi, FaUsers } from "react-icons/fa";
import { LuDownload } from "react-icons/lu";

import banner2 from "./banners/Rectangle 19.png";
import banner1 from "./banners/Rectangle 18.png";
import TaxiArt from "./TaxiPicture/taxiArt.png";
import qrCode from "../public/bodyIcons/marankooQRCode.svg";
import taxiicon1 from "../public/taxiCarIcon.png";
import taxiicon2 from "../public/taxiLocatino-Icon.png";
import "./details.css";

const Details = () => {
    return (
        <section className="home-details mk-home-details" aria-label="مزایا و دانلود اپلیکیشن مارانکو">
            <div className="home-banners">
                <div className="home-banner-card mk-home-banner">
                    <img
                        src={banner2}
                        alt="خدمات سفر مارانکو"
                        loading="lazy"
                        decoding="async"
                        width="622"
                        height="270"
                    />
                </div>
                <div className="home-banner-card mk-home-banner">
                    <img
                        src={banner1}
                        alt="رزرو تاکسی بین شهری مارانکو"
                        loading="lazy"
                        decoding="async"
                        width="622"
                        height="270"
                    />
                </div>
            </div>

            <div className="home-benefits">
                <article className="home-benefit-card mk-feature-card">
                    <div className="home-benefit-media">
                        <img
                            src={taxiicon1}
                            alt="خودروی سفر بین شهری"
                            loading="lazy"
                            decoding="async"
                            width="200"
                            height="140"
                        />
                    </div>
                    <div className="home-benefit-copy home-benefit-copy--accent-right">
                        <h2>سفر مطمئن و سریع</h2>
                        <p>
                            سرویس اجاره تاکسی بین‌شهری ما، سفری مطمئن و آسوده را بدون محدودیت زمان حرکت و دغدغه‌ی ایستگاه‌ها و ترمینال‌ها برایتان فراهم می‌کند. خدمات ما جایگزینی مناسب برای اتوبوس، قطار و حتی هواپیما (در شرایط تکمیل ظرفیت) است.
                        </p>
                    </div>
                </article>

                <article className="home-benefit-card home-benefit-card--reverse mk-feature-card">
                    <div className="home-benefit-copy home-benefit-copy--accent-left">
                        <h2>سفری آسوده و راحت</h2>
                        <p>
                            سرویس تاکسی بین‌شهری ما پاسخی مناسب برای مسافران هوشمندی است که می‌خواهند از محدودیت‌ها و پیچیدگی‌های سیستم حمل و نقل عمومی عبور کنند و سفری سریع، اختصاصی و به‌مراتب راحت‌تر را تجربه کنند. با خدمات تاکسی ما، نه‌تنها زمان حرکت را طبق برنامه‌ی شخصی خودتان تعیین می‌کنید، بلکه از مبدأ تا مقصد بدون توقف و با آسودگی کامل همراه خواهید بود.
                        </p>
                    </div>
                    <div className="home-benefit-media">
                        <img
                            src={taxiicon2}
                            alt="مسیریابی سفر بین شهری"
                            loading="lazy"
                            decoding="async"
                            width="200"
                            height="140"
                        />
                    </div>
                </article>
            </div>

            <div className="home-app-card">
                <div className="home-app-art" aria-hidden="true">
                    <img
                        src={TaxiArt}
                        alt=""
                        loading="lazy"
                        decoding="async"
                        width="310"
                        height="240"
                    />
                </div>

                <div className="home-app-copy">
                    <p className="home-app-eyebrow">مارانکو همیشه همراه شما</p>
                    <h2>آسان‌تر با اپلیکیشن</h2>
                    <p className="home-app-description">
                        برای دسترسی سریع‌تر به خدمات، نسخه مناسب خودتان را مستقیماً دریافت کنید.
                    </p>

                    <div className="home-app-actions">
                        <a
                            href="https://marankoo.ir/wp-content/uploads/android/maranko-passenger.apk"
                            className="home-app-button home-app-button--passenger"
                        >
                            <FaUsers aria-hidden="true" />
                            <span>دریافت اپلیکیشن مسافر</span>
                            <LuDownload aria-hidden="true" />
                        </a>
                        <a
                            href="https://marankoo.ir/wp-content/uploads/android/maranko-driver.apk"
                            className="home-app-button home-app-button--driver"
                        >
                            <FaTaxi aria-hidden="true" />
                            <span>دریافت اپلیکیشن راننده</span>
                            <LuDownload aria-hidden="true" />
                        </a>
                    </div>
                </div>

                <div className="home-app-qr">
                    <div className="home-qr-frame">
                        <img
                            src={qrCode}
                            alt="QR دانلود اپلیکیشن مسافر مارانکو"
                            loading="lazy"
                            decoding="async"
                            width="180"
                            height="180"
                        />
                    </div>
                    <p>برای دانلود اپلیکیشن مسافر اسکن کنید</p>
                </div>
            </div>
        </section>
    );
};

export default Details;
